import styled from 'styled-components';

export const Container = styled.div`
  //display: flex;
  //position: relative;
  flex-direction: column;
  margin-top: 1rem;
  margin-left: 2rem;
  display: flex;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.0rem;

  .MuiTypography-colorPrimary {
    color : #79ff4d;
  }

  .MuiTypography-colorSecondary {
    color : #ff3300;
  }

  .Container__dados_tanque_int {
    display: grid;
    margin-top: 2rem;
    margin-left: 2rem;
    grid-gap: 1.2rem;
    @media (max-width: 768px) {
      margin-top: 4rem;
    }
  }

  .Container__cabecalho_dados {
    position: absolute;
    left: 22rem;
    top: 2;
    color:#234143;
  }

  @keyframes opacitys {
    from { color:red;}
    to { color:#fff; }
  }

  .Container__footer_dados {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-columns: 150px 150px ;
    grid-gap: 1rem;
    position: absolute;
    left: 16rem;
    top: 23.3rem;
    @media (min-width: 960px){
      top: 23rem;
      & h6{
        font-size:1.5909rem;
      }
    
    }

    .receb{
      color:#fbf500
    }

    .abastec{
      animation: opacitys .5s alternate infinite;
      -webkit-animation: opacitys .5s  alternate infinite;
    }
  }

  
  

  .Container__body_dados {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-columns: 100px 90px 90px;
    grid-gap: 0.0rem;
    position: absolute;
    left: 20.5rem;
    top: 4.4rem;
    font-size: 1.1rem !important;
    line-height: 1.55;
    font-weight:500;
    color:#234143;

  }

  .Container__barra_progresso_dados {
    display: flex;
    position: absolute;
    height: 13rem;
    left: 11rem;
    top: 10rem;
    padding-bottom:2px;
    padding-top:1px;

   .MuiSlider-vertical .MuiSlider-track, .MuiSlider-vertical .MuiSlider-rail{
        width:10px;
    }
   .MuiSlider-vertical .MuiSlider-rail{
      background-color:#fff;
      opacity:1 !important;
    }

    .tnqBar{
      .MuiSlider-root.MuiSlider-vertical{
        cursor:auto;
      }
    }

    .tempBar{
      position:relative;
      right: 26px;
      top:10px;
      padding-top:3px;
      .MuiSlider-root.Mui-disabled{
        color:red;
        width:0;
      }
      
      .MuiSlider-thumb.Mui-disabled{
        height:10px;
        width:10px;
        
      }
      .MuiSlider-vertical .MuiSlider-thumb.Mui-disabled{
        margin-top: -9px;
        margin-left:-5px;
      }

      .MuiSlider-vertical .MuiSlider-markLabel {
        font-size:1rem;
        color:#252525;

        @media (min-width: 960px){
          font-size:1rem;
        
        }

        @media (min-width: 600px){
          font-size:1rem;
        
        }
      }
    }

  }



`;

export const Sidebar = styled.ul`
  width: 18rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: absolute;
  right: 0;

  li {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 1rem;

    strong {
      font-size: 0.9rem;
      font-weight: 400;
      color: #999;
    }

    p {
      font-size: 1.3rem;
      color: #666;
    }

    :not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    }

    &.active p {
      color: green;
      font-size: 1.5rem;
    }
  }
`;
